// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__107Sk","questions":"styles_questions__2ficC","footer":"styles_footer__2m1jA"};